// Deterministic configuration for the customer matching algorithm.
// Do not tune these in component code.

// Legal suffix tokens are stripped from the tail of a tokenized name
// only if at least one meaningful token remains.
export const LEGAL_SUFFIX_TOKENS: ReadonlySet<string> = new Set([
  "llc",
  "inc",
  "corp",
  "corporation",
  "co",
  "company",
  "ltd",
  "limited",
]);

// Scoring weights for the weighted-sum branch of the score function.
// coverage + editSimilarity + order weights must sum to 1.0.
export const SCORE_WEIGHT_COVERAGE = 0.6;
export const SCORE_WEIGHT_EDIT_SIMILARITY = 0.25;
export const SCORE_WEIGHT_ORDER = 0.15;

// If the normalized customer phrase appears verbatim inside the
// normalized filename, the score is at least this value.
export const PHRASE_BONUS = 0.98;

// Number of top suggestions kept per file.
export const TOP_SUGGESTIONS_PER_FILE = 5;

// Bucket 1 = high confidence.
export const BUCKET_1_MIN_SCORE = 0.9;
export const BUCKET_1_MIN_MARGIN = 0.12;

// Bucket 2 = plausible / mid confidence.
export const BUCKET_2_MIN_SCORE = 0.72;
export const BUCKET_2_MIN_MARGIN = 0.05;
